var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {},
    [
      _c(
        "v-dialog",
        {
          staticClass: "popbox",
          attrs: {
            name: "dialog2",
            title: _vm.dialogTitle,
            "close-on-click-modal": "",
            modal: true,
            width: 668,
            "append-to-body": "",
          },
          on: {
            open: _vm.showopen,
            "after-close": _vm.handleAfterClose,
            confirm: _vm.handleConfirm,
          },
          model: {
            value: _vm.showInputDialog,
            callback: function ($$v) {
              _vm.showInputDialog = $$v
            },
            expression: "showInputDialog",
          },
        },
        [
          _c(
            "v-form",
            { ref: "form", attrs: { model: _vm.ruleForm, rules: _vm.rules } },
            [
              _c(
                "v-form-item",
                { attrs: { label: "版本ID", prop: "id", required: false } },
                [
                  _c("v-input", {
                    attrs: { type: "text", name: "id", disabled: true },
                    model: {
                      value: _vm.ruleForm.id,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "id", $$v)
                      },
                      expression: "ruleForm.id",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-form-item",
                { attrs: { label: "产品", prop: "product_keys" } },
                [
                  _c("v-select", {
                    attrs: {
                      isMultiple: "",
                      multipleShowAll: "",
                      id: "product_keys",
                      disabled: "",
                      "is-search": "",
                      "is-clear": "",
                      insertContains: "product_keys",
                      value: _vm.ruleForm.product_keys,
                      name: "product_keys",
                      options: _vm.productKeyOptins,
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-form-item",
                { attrs: { label: "软件版本", prop: "software_version" } },
                [
                  _c("v-input", {
                    attrs: { type: "text", name: "software_version" },
                    model: {
                      value: _vm.ruleForm.software_version,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "software_version", $$v)
                      },
                      expression: "ruleForm.software_version",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-form-item",
                {
                  attrs: {
                    label: "父版本",
                    prop: "previous_ver_id",
                    required: false,
                  },
                },
                [
                  _c("v-select", {
                    attrs: {
                      id: "fat_target_version",
                      "is-search": "",
                      "is-clear": "",
                      insertContains: "fat_target_version",
                      name: "previous_ver_id",
                      options: _vm.resver,
                    },
                    model: {
                      value: _vm.ruleForm.previous_ver_id,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "previous_ver_id", $$v)
                      },
                      expression: "ruleForm.previous_ver_id",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-form-item",
                {
                  attrs: {
                    label: "子版本",
                    prop: "target_ver_id",
                    required: false,
                  },
                },
                [
                  _c("v-select", {
                    attrs: {
                      id: "son_target1_version",
                      "is-search": "",
                      "is-clear": "",
                      insertContains: "son_target1_version",
                      name: "target_ver_id",
                      options: _vm.resver,
                    },
                    model: {
                      value: _vm.ruleForm.next_ver_id,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "next_ver_id", $$v)
                      },
                      expression: "ruleForm.next_ver_id",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-form-item",
                {
                  staticClass: "listfile",
                  attrs: {
                    label: "固件上传",
                    prop: "listFile",
                    required: false,
                  },
                },
                [
                  _c("v-upload", {
                    ref: "upload",
                    attrs: {
                      action: "/cgi-bin/upload",
                      name: "upload",
                      accept: ".trx,.bin",
                      "show-file-list": "",
                      "on-change": _vm.hidemsg,
                      WfileName: this.fileName,
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-form-item",
                { attrs: { label: "版本类型", prop: "version_type" } },
                [
                  _c("v-select", {
                    attrs: {
                      id: "list_edit_version_type",
                      insertContains: "list_edit_version_type",
                      name: "version_type",
                      options: _vm.versionTypeOptions,
                    },
                    model: {
                      value: _vm.ruleForm.version_type,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "version_type", $$v)
                      },
                      expression: "ruleForm.version_type",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-form-item",
                { attrs: { label: "硬件版本", prop: "hardware_version" } },
                [
                  _c("v-input", {
                    attrs: { type: "text", name: "hardware_version" },
                    model: {
                      value: _vm.ruleForm.hardware_version,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "hardware_version", $$v)
                      },
                      expression: "ruleForm.hardware_version",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-form-item",
                { attrs: { label: "版本密码", prop: "version_secret" } },
                [
                  _c("v-input", {
                    attrs: { type: "text", name: "version_secret" },
                    model: {
                      value: _vm.ruleForm.version_secret,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "version_secret", $$v)
                      },
                      expression: "ruleForm.version_secret",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-form-item",
                { attrs: { label: "公司", prop: "enterprise_name" } },
                [
                  _c("v-input", {
                    attrs: { type: "text", name: "enterprise_name" },
                    model: {
                      value: _vm.ruleForm.enterprise_name,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "enterprise_name", $$v)
                      },
                      expression: "ruleForm.enterprise_name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-form-item",
                {
                  attrs: {
                    label: "是否禁用云服务",
                    prop: "disabled_cloud",
                    required: false,
                  },
                },
                [
                  _c("v-radio", {
                    staticClass: "options",
                    attrs: {
                      name: "disabled_cloud",
                      options: _vm.disabledCloudOptions,
                    },
                    model: {
                      value: _vm.ruleForm.disabled_cloud,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "disabled_cloud", $$v)
                      },
                      expression: "ruleForm.disabled_cloud",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-form-item",
                {
                  attrs: {
                    label: "是否跳过当前版本",
                    prop: "recursion",
                    required: false,
                  },
                },
                [
                  _c("v-radio", {
                    staticClass: "options",
                    attrs: { name: "recursion", options: _vm.recursionList },
                    model: {
                      value: _vm.ruleForm.recursion,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "recursion", $$v)
                      },
                      expression: "ruleForm.recursion",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-form-item",
                { attrs: { label: "系统", prop: "system" } },
                [
                  _c("v-input", {
                    attrs: { type: "text", name: "system" },
                    model: {
                      value: _vm.ruleForm.system,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "system", $$v)
                      },
                      expression: "ruleForm.system",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-form-item",
                { attrs: { label: "作者描述", prop: "author_description" } },
                [
                  _c("v-input", {
                    staticClass: "Description",
                    attrs: {
                      type: "textarea",
                      name: "author_description",
                      maxlength: 200,
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.ruleForm.author_description,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "author_description", $$v)
                      },
                      expression: "ruleForm.author_description",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-form-item",
                { attrs: { label: "语言", prop: "language" } },
                [
                  _c("v-checkbox-group", {
                    attrs: { name: "language", options: _vm.languageOptions },
                    on: { click: _vm.handleClick },
                    model: {
                      value: _vm.languageData,
                      callback: function ($$v) {
                        _vm.languageData = $$v
                      },
                      expression: "languageData",
                    },
                  }),
                ],
                1
              ),
              _vm._l(_vm.ruleForm.descp_lang, function (item, index) {
                return _c(
                  "v-form-item",
                  {
                    key: index,
                    staticClass: "descp-language",
                    attrs: { prop: "descpSelect" },
                  },
                  [
                    _c(
                      "v-form-item",
                      { attrs: { prop: "change_log" } },
                      [
                        _c("template", { slot: "label" }, [
                          _c("span", { staticClass: "required" }),
                          _c("span", [
                            _vm._v(
                              "更新日志(" +
                                _vm._s(_vm.$LANGUAGE[item.language]) +
                                ")"
                            ),
                          ]),
                        ]),
                        _c("v-input", {
                          staticClass: "Description",
                          attrs: {
                            type: "textarea",
                            name: "change_log",
                            maxlength: 200,
                            "show-word-limit": "",
                          },
                          model: {
                            value: _vm.ruleForm.descp_lang[index].change_log,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.ruleForm.descp_lang[index],
                                "change_log",
                                $$v
                              )
                            },
                            expression: "ruleForm.descp_lang[index].change_log",
                          },
                        }),
                      ],
                      2
                    ),
                    _c(
                      "v-form-item",
                      { attrs: { prop: "new_func" } },
                      [
                        _c("template", { slot: "label" }, [
                          _c("span", { staticClass: "required" }),
                          _c("span", [
                            _vm._v(
                              "新功能(" +
                                _vm._s(_vm.$LANGUAGE[item.language]) +
                                ")"
                            ),
                          ]),
                        ]),
                        _c("v-input", {
                          staticClass: "Description",
                          attrs: {
                            type: "textarea",
                            name: "new_func",
                            maxlength: 200,
                            "show-word-limit": "",
                          },
                          model: {
                            value: _vm.ruleForm.descp_lang[index].new_func,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.ruleForm.descp_lang[index],
                                "new_func",
                                $$v
                              )
                            },
                            expression: "ruleForm.descp_lang[index].new_func",
                          },
                        }),
                      ],
                      2
                    ),
                    _c(
                      "v-form-item",
                      { attrs: { prop: "optimization" } },
                      [
                        _c("template", { slot: "label" }, [
                          _c("span", { staticClass: "required" }),
                          _c("span", [
                            _vm._v(
                              "优化内容(" +
                                _vm._s(_vm.$LANGUAGE[item.language]) +
                                ")"
                            ),
                          ]),
                        ]),
                        _c("v-input", {
                          staticClass: "Description",
                          attrs: {
                            type: "textarea",
                            name: "optimization",
                            maxlength: 200,
                            "show-word-limit": "",
                          },
                          model: {
                            value: _vm.ruleForm.descp_lang[index].optimization,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.ruleForm.descp_lang[index],
                                "optimization",
                                $$v
                              )
                            },
                            expression:
                              "ruleForm.descp_lang[index].optimization",
                          },
                        }),
                      ],
                      2
                    ),
                    _c(
                      "v-form-item",
                      { attrs: { prop: "memo" } },
                      [
                        _c("template", { slot: "label" }, [
                          _c("span", { staticClass: "required" }),
                          _c("span", [
                            _vm._v(
                              "备注(" +
                                _vm._s(_vm.$LANGUAGE[item.language]) +
                                ")"
                            ),
                          ]),
                        ]),
                        _c("v-input", {
                          staticClass: "Description",
                          attrs: {
                            type: "textarea",
                            name: "memo",
                            maxlength: 200,
                            "show-word-limit": "",
                          },
                          model: {
                            value: _vm.ruleForm.descp_lang[index].memo,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.ruleForm.descp_lang[index],
                                "memo",
                                $$v
                              )
                            },
                            expression: "ruleForm.descp_lang[index].memo",
                          },
                        }),
                      ],
                      2
                    ),
                  ],
                  1
                )
              }),
            ],
            2
          ),
          _c("v-loading", {
            staticClass: "loading-box",
            attrs: { visible: !_vm.upTips, name: "loading4" },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }